import { useChatbotList } from 'hooks/useChatbotList';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function LoadBot() {
  const { isFetching, isSuccess, data } = useChatbotList();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (isSuccess && data?.length) {
      const id = data[0].id;

      navigate(`/${id}/edit`);
    }
  }, [navigate, isSuccess, data]);

  if (!isFetching && isSuccess && (!data || !data?.length)) {
    return <h1 className="text-balance">{t('errors.noChatbotsAssigned')}</h1>;
  }

  return <h1 className="text-balance">{t('common.loading')}</h1>;
}
